import { render } from "./RegisterPanel.vue?vue&type=template&id=002f36d6&scoped=true"
import script from "./RegisterPanel.vue?vue&type=script&lang=js"
export * from "./RegisterPanel.vue?vue&type=script&lang=js"

import "./RegisterPanel.vue?vue&type=style&index=0&id=002f36d6&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002f36d6"]])

export default __exports__